import { useState } from "react";
import { Button, Paper, Typography } from "@mui/material";
import WaitlistDialog from "./WaitlistDialog";

// Venda de novas assinaturas fechada (salesOpen=false no pricing do backend):
// no lugar dos planos/checkout, aviso + lista de espera (POST /access/waitlist).
export default function SalesClosedNotice() {
  const [waitlistOpen, setWaitlistOpen] = useState(false);

  return (
    <Paper
      elevation={0}
      sx={{
        maxWidth: "560px",
        margin: "0 auto",
        padding: { xs: "28px", md: "36px" },
        textAlign: "center",
        background: "linear-gradient(135deg, rgba(26, 49, 60, 0.6) 0%, rgba(4, 9, 10, 0.8) 100%)",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: "24px",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: "#ffffff",
          fontWeight: 700,
          fontFamily: "Oxanium, sans-serif",
          letterSpacing: "-0.02em",
          marginBottom: "12px",
        }}
      >
        Novas assinaturas encerradas
      </Typography>
      <Typography sx={{ color: "rgba(255,255,255,0.7)", lineHeight: 1.6, marginBottom: "24px" }}>
        No momento não estamos abrindo novas assinaturas do Dr. Weedy. Entre na lista de
        espera e avisamos quando reabrirmos. Quem já é assinante continua com acesso normalmente.
      </Typography>
      <Button
        onClick={() => setWaitlistOpen(true)}
        variant="contained"
        sx={{
          background: "linear-gradient(135deg, #FF8904 0%, #E7000B 100%)",
          borderRadius: "16px",
          textTransform: "none",
          fontSize: "16px",
          fontWeight: 700,
          padding: "14px 32px",
          color: "#ffffff",
        }}
      >
        Entrar na lista de espera
      </Button>
      <WaitlistDialog open={waitlistOpen} onClose={() => setWaitlistOpen(false)} />
    </Paper>
  );
}
